import * as React from "react";
import ListItem from "./list-item";
export default class ProductList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "product-list" },
            React.createElement("div", { className: "list-header" },
                React.createElement("h4", null,
                    "PRODUCT LIST (",
                    this.props.products.length,
                    ")")),
            this.props.products.map((product, index) => {
                return React.createElement(ListItem, { product: product, key: index });
            }),
            React.createElement("div", { className: "store-button" },
                React.createElement("a", { href: "/Products/ShoppingListStores" },
                    React.createElement("button", { className: "btn-primary btn-primary__filled" }, "VIEW PRODUCTS BY STORE")))));
    }
}
;
//# sourceMappingURL=product-list.js.map